import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Gates the battery 90-99% health tier feature by market and category.
 *
 * Part of the Battery Range Picker project (APAC-855): some markets display
 * three-level battery health levels (New/100%, 90-99%, 80-89%) instead of the
 * default two-level system (New, Standard). Controlled via feature flags for country and
 * category rollout (initial rollout enabled for Japan & Smartphones).
 *
 * Returns whether the current market has the feature enabled and which
 * categories support it.
 */
export function useBattery9099() {
  const { market } = useMarketplace()
  const {
    FF_BO_SELLER_ENABLE_BATTERY_90_99_COUNTRIES,
    FF_BO_SELLER_ENABLE_BATTERY_90_99_CATEGORIES,
  } = useRuntimeConfig().public

  const enabledCountries = (FF_BO_SELLER_ENABLE_BATTERY_90_99_COUNTRIES ?? '')
    .toString()
    .split(',')
    .filter(Boolean)

  const battery9099EnabledCategories = (
    FF_BO_SELLER_ENABLE_BATTERY_90_99_CATEGORIES ?? ''
  )
    .toString()
    .split(',')
    .map(Number)
    .filter(Boolean)

  const isBattery9099EnabledCountry = enabledCountries.includes(
    market.countryCode,
  )

  return {
    isBattery9099EnabledCountry,
    battery9099EnabledCategories,
  }
}
